export interface TestimonialImage {
  image: string;
  alt: string;
}

export const testimonialImages: TestimonialImage[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/22MafTpuXFMaTNdAmiNYSE/Imagen_de_ChatGPT_27_sept_2026,_14_24_56.webp',
    alt: 'Mensaje de Facebook Messenger de Javier Delgado sobre las sesiones completas de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/mmcqkPsD1Ad7csTWsX9iWZ/Imagen_de_ChatGPT_27_sept_2026,_14_24_12_2.jpg',
    alt: 'Mensaje de Facebook Messenger de Sergio Martín sobre el tiempo que le ahorra el material.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/nnss6tkfDtzXAvGmZKGXEJ/Imagen_de_ChatGPT_27_sept_2026,_14_27_57.webp',
    alt: 'Publicación de Facebook de Rubén Torres sobre el análisis de partido de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/xb6DDgeVYrokr7chJcp3cB/Imagen_de_ChatGPT_27_sept_2026,_14_26_50.webp',
    alt: 'Comentario de Instagram sobre el protocolo para sesiones críticas de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/uVBLPMvnj2PKNAf4h1bnPh/Imagen_de_ChatGPT_27_sept_2026,_14_29_08.webp',
    alt: 'Correo electrónico de Carlos Giménez sobre la parte de scouting de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/msjWNuZSyATEESDe9T46g6/Imagen_de_ChatGPT_27_sept_2026,_14_30_36.webp',
    alt: 'Hilo de comentarios de Instagram sobre la gestión de grupo con Balonmano Pro 360.'
  }
];
